import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const RetouchingDetailManager = () => {
  const [retouching, setRetouching] = useState({});
  const [status, setStatus] = useState(1);
  const [editors, setEditors] = useState([]); // List of editors
  const [selectedEditor, setSelectedEditor] = useState(""); // Selected editor  const [fileLocation, setFileLocation] = useState("");
  const [fileLocation, setFileLocation] = useState("");

  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const getRetouchingById = async () => {
    try {
      const response = await axios.get(`/retouching/${id}`);
      setRetouching(response.data);
      setSelectedEditor(response.data.editor || ""); // Set selected editor from fetched data
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1); // Set status from fetched data
    } catch (error) {
      console.log(error);
    }
  };

  const getEditors = async () => {
    try {
      const response = await axios.get("/user/allUsers");
      const editorUsers = response.data.filter(
        (user) => user.role === "editor"
      );
      setEditors(editorUsers);
    } catch (error) {
      console.error("Error fetching editors:", error);
    }
  };

  useEffect(() => {
    getRetouchingById();
    getEditors();
  }, []);

  const updateRetouching = async () => {
    try {
      await axios.put(`/retouching/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/retouching-manager");
    } catch (error) {
      console.log(error);
    }
  };

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  return (
    <Layout>
      <div className="container mt-4">
        <div className="row">
          {/* Left Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Event Name:</strong> {retouching.order_name}
                </p>
                <p>
                  <strong>Service Type:</strong>{" "}
                  {retouching?.serviceId?.service}
                </p>
                <p>
                  <strong>Album Type:</strong> {retouching.order_name}
                </p>
              </div>
            </div>{" "}
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Cropping & Retouching :</strong>{" "}
                  {retouching.cropping_straightening}
                </p>
                <p>
                  <strong>color_correction</strong>{" "}
                  {retouching.color_correction}
                </p>
                <p>
                  <strong>sharpening :</strong> {retouching.sharpening}
                </p>{" "}
                <p>
                  <strong>skin_sofening :</strong> {retouching.skin_sofening}
                </p>
                <p>
                  <strong>eyes_whitening :</strong> {retouching.eyes_whitening}
                </p>
                <p>
                  <strong>hands_feet_redness :</strong>{" "}
                  {retouching.hands_feet_redness}
                </p>{" "}
                <p>
                  <strong>teeth_whitening :</strong>{" "}
                  {retouching.teeth_whitening}
                </p>
                <p>
                  <strong>background_extend :</strong>{" "}
                  {retouching.background_extend}
                </p>
                <p>
                  <strong>Quantity:</strong> {retouching.quantity}
                </p>
                <p>
                  <strong>Upload :</strong> {retouching.images}
                </p>
                <p>
                  <strong>Additional Notes :</strong>{" "}
                  {retouching.additional_notes}
                </p>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Order Operations</div>
              <div className="card-body">
                <p>
                  <strong>Client ID:</strong> {retouching.userId?.id}
                </p>
                <p>
                  <strong>Order ID:</strong> {retouching.id}
                </p>
                <p>
                  <strong>User Feedback:</strong> {retouching.sampleFeedback}
                </p>
                <p>
                  <strong>Order Place Date:</strong>{" "}
                  {new Date(retouching.createdAt).toLocaleDateString()}
                </p>

                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>

                <div className="mt-3">
                  <label className="form-label">Select Editor</label>
                  <select
                    className="form-select"
                    value={selectedEditor}
                    onChange={(e) => setSelectedEditor(e.target.value)}
                  >
                    <option value="">Select an editor</option>
                    {editors.map((ed) => (
                      <option key={ed._id} value={ed.fname}>
                        {ed.fname}
                      </option>
                    ))}
                  </select>
                </div>

                <label className="form-label mt-3">File Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={fileLocation}
                  onChange={(e) => setFileLocation(e.target.value)}
                />

                <div>
                  <label className="form-label mt-3">Message</label>
                  <input
                    type="text"
                    className="form-control"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>

                <button
                  onClick={updateRetouching}
                  className="btn text-light bg_maincolor mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RetouchingDetailManager;
